module.exports = __webpack_public_path__ + "static/media/safety-batteries-1.2b93886a.png";